module.exports = __webpack_public_path__ + "img/file-alt-solid.cf5e4039.svg";